"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isToday_1 = __importDefault(require("date-fns/isToday"));
var parseISO_1 = __importDefault(require("date-fns/parseISO"));
var format_1 = __importDefault(require("./format"));
function formatTimeAndDate(timeStamp, formats) {
    if (formats === void 0) { formats = {}; }
    var _a = __assign({ timeFormat: 'HH:mm', dateFormat: 'MMM dd' }, formats), dateFormat = _a.dateFormat, timeFormat = _a.timeFormat;
    return {
        date: format_1.default(timeStamp, dateFormat),
        time: format_1.default(timeStamp, timeFormat),
        isToday: isToday_1.default(parseISO_1.default(timeStamp)),
    };
}
exports.default = formatTimeAndDate;
//# sourceMappingURL=formatTimeAndDate.js.map